export const getLanguages = () => {

    const languages = [
        { 'name' : 'Español', 'value' : 'es'},
        { 'name' : 'Valencià', 'value' : 'ca'},      
        { 'name' : 'English', 'value' : 'en'}
    ];

    return languages;
}

// use localStorage to keep value
export const getLanguage = () => {

    //const cookies = new Cookies();
    //return cookies.get('language');
    return localStorage.getItem("i18nextLng");
}

export const setLanguage = (language) => {

    //const cookies = new Cookies();
    //cookies.set("language",language,{path: '/'});
    localStorage.setItem("i18nextLng",language);
}